import Solution from "./solution";
// import compare from "../../Utils/compare";

const testCases = [
  {
    str1: "abcde",
    str2: "ace",
  },
  {
    str1: "ABCD",
    str2: "ACBAD",
  },
  {
    str1: "ABCD",
    str2: "FG",
  },
  {
    str1: "EABCD",
    str2: "ACBADE",
  },
  {
    str1: "ABCDE",
    str2: "EACBAD",
  },
];

const test = (code) => {
  try {
    const updatedFunc = `${code.trim()}`;
    const output = new Function(updatedFunc);

    for (let test of testCases) {
      const { str1, str2 } = test;
      let outcome1 = output()(str1, str2);
      let outcome2 = Solution(str1, str2);
      const result = outcome1 === outcome2;
      if (!result) {
        return {
          status: "failed",
          details: { input: test, output: outcome1, expected: outcome2 },
        };
      }
    }

    return { status: "success", details: {} };
  } catch (e) {
    return {
      status: "error",
      details: { message: `${e.name}: ${e.message}` },
    };
  }
};

export default test;
